import React from "react";
import {
  Create,
  SimpleForm,
  FileField,
  Toolbar,
  FileInput,
  ListButton,
  SaveButton,
} from "react-admin";
import { onBulckMicroTaskValidationCreate } from "../../Service/Validation/AddBonusValidation";
import { MicroTaskStatusSelectInput } from '../../UI/Input/SelectInput'
import Grid from "@material-ui/core/Grid";

const PageTitle = () => {
  return <span>Add Bonus</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AdminBulckMicrotaskCreate = (props) => {

  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onBulckMicroTaskValidationCreate}>
        <SanitizedGrid container spacing={3} fullWidth>
          <FileInput source="attachments">
            <FileField source="src" title="title" />
          </FileInput>
          <MicroTaskStatusSelectInput label="Status" source="type" fullWidth/>

        </SanitizedGrid>

      </SimpleForm>
    </Create>
  );
};
export default AdminBulckMicrotaskCreate;
